import { useEffect } from "react";

interface InfogramEmbedProps {
  code: string
}

const InfogramEmbed = ({ code }: InfogramEmbedProps) => {

  function extractDataFromCode(code) {
    var regex = /data-id="([^"]*)"[\s\S]*?data-title="([^"]*)"/;
    var match = code.match(regex);
  
    if (match) {
      var dataId = match[1];
      var dataTitle = match[2];
  
      return {
        dataId: dataId,
        dataTitle: dataTitle
      };
    } else {
      return null;
    }
  }
  var extractedData = extractDataFromCode(code);

  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.id = 'infogram-async';
    script.src = 'https://e.infogram.com/js/dist/embed-loader-min.js';

    if (!document.getElementById('infogram-async')) {
      document.head.appendChild(script);
    }
  }, []);

  const dataId = extractedData ? extractedData.dataId : '';
  const dataTitle = extractedData ? extractedData.dataTitle : '';

  return (
    <div
      className="infogram-embed"
      data-id={dataId}
      data-type="interactive"
      data-title={dataTitle}
      style={{width: '100%'}}
    ></div>
  );
};


export default InfogramEmbed
